webpackJsonp([9],{

/***/ 2332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_keymirror__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_keymirror___default()(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createActionKeys('UPDATE_BUSINESS_DESCRIPTION'))));

/***/ }),

/***/ 2346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export Options */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_hot_loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Button__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Options_scss__ = __webpack_require__(5149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Options_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Options_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_BusinessListConstants__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_common_businessList_businessListActions__ = __webpack_require__(699);








var _strong;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}

/* eslint-disable no-nested-ternary */

/* eslint-disable react/no-did-update-set-state */

/* eslint-disable react/no-did-mount-set-state */











var Options = /*#__PURE__*/function (_React$Component) {
  function Options(props) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Options);

    _this2 = _callSuper(this, Options, [props]);

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "handleRadioChange", function (e) {
      _this2.props.setSortBy(e.currentTarget.value);
    });

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "handleFilter", function (e) {
      _this2.sendFilterAndSortEventsToSegment();

      var _this2$props = _this2.props,
          getServiceProviders = _this2$props.getServiceProviders,
          serviceProviders = _this2$props.serviceProviders,
          closeFilter = _this2$props.closeFilter,
          sortByValue = _this2$props.sortByValue;
      if (closeFilter) closeFilter();

      var sortedBy = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(serviceProviders, 'response.sortedBy', 'name');

      if (sortByValue !== sortedBy) {
        getServiceProviders({
          sortBy: sortByValue,
          // start back at the new beginning of result set if a sort or filter is applied
          offset: __WEBPACK_IMPORTED_MODULE_16__common_BusinessListConstants__["a" /* DEFAULT_OFFSET */],
          limit: __WEBPACK_IMPORTED_MODULE_16__common_BusinessListConstants__["b" /* PROS_PER_PAGE */]
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "sendToTracker", function (description) {
      __WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform__["tracker"].track('Item Clicked', _objectSpread({}, {
        activityLocation: 'SP : Business List',
        description: description
      }));
    });

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "sendSortByEvent", function (sortByValue) {
      switch (sortByValue) {
        case 'ratings':
          _this2.sendToTracker('Clicks on customer rating sort by');

          break;

        case 'reviews':
          _this2.sendToTracker('Clicks on total reviews sort by');

          break;

        default:
          _this2.sendToTracker('Clicks on business name sort by');

          break;
      }
    });

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "props", void 0);

    _this2.handleRadioChange = _this2.handleRadioChange.bind(_this2);
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Options, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Options, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var serviceProviders = this.props.serviceProviders;

      var sortedBy = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(serviceProviders, 'response.sortedBy', 'name');

      this.props.setSortBy(sortedBy);
    }
  }, {
    key: "sendFilterAndSortEventsToSegment",
    value: function sendFilterAndSortEventsToSegment() {
      var sortByValue = this.props.sortByValue;
      this.sendSortByEvent(sortByValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
        className: "businesslist-options"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
        className: "filter-options"
      }, _strong || (_strong = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, " Sort by ")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input___default.a, {
        id: "filterOptionsSortByName",
        value: "name",
        type: "radio",
        role: "radio",
        label: "Business name (A-Z)",
        name: "filterOptionsSortBy",
        onClick: function onClick(e) {
          return _this3.handleRadioChange(e);
        },
        defaultChecked: true,
        checked: this.props.sortByValue === 'name'
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input___default.a, {
        id: "filterOptionsSortByRating",
        value: "ratings",
        type: "radio",
        role: "radio",
        label: "Customer rating (high to low)",
        name: "filterOptionsSortBy",
        onClick: function onClick(e) {
          return _this3.handleRadioChange(e);
        },
        checked: this.props.sortByValue === 'ratings'
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input___default.a, {
        id: "filterOptionsSortByReview",
        value: "reviews",
        type: "radio",
        role: "radio",
        label: "Total reviews (high to low)",
        name: "filterOptionsSortBy",
        onClick: function onClick(e) {
          return _this3.handleRadioChange(e);
        },
        checked: this.props.sortByValue === 'reviews'
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
        className: "filter-options-apply text-center"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Button___default.a, {
        id: "filter-options-apply-button",
        className: "apply-button",
        onClick: function onClick() {
          return _this3.handleFilter();
        },
        bsSize: "small",
        bsStyle: "default-office",
        flat: true
      }, "APPLY"))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_8_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(function (state) {
  return {
    serviceProviders: state.businessList.getServiceProviders
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_17__app_common_businessList_businessListActions__["a" /* default */])), __WEBPACK_IMPORTED_MODULE_9_recompose_pure___default.a)(Options)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 2347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROS_PER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_OFFSET; });
var PROS_PER_PAGE = 10;
var DEFAULT_OFFSET = 0;

/***/ }),

/***/ 2348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_touch_device__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_touch_device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_is_touch_device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Button__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BusinessCard_scss__ = __webpack_require__(5151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BusinessCard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__BusinessCard_scss__);
var _div, _Col;










var usingTouchDevice = __WEBPACK_IMPORTED_MODULE_2_is_touch_device___default()();

var BusinessCard = function BusinessCard(props) {
  var _props$sp = props.sp,
      proType = _props$sp.proType,
      _props$sp$starRating = _props$sp.starRating,
      starRating = _props$sp$starRating === void 0 ? 0 : _props$sp$starRating,
      displayReviewCount = _props$sp.displayReviewCount,
      primaryAddress = _props$sp.primaryAddress,
      name = _props$sp.name,
      id = _props$sp.id,
      activityCount = _props$sp.activityCount,
      accessEndsAt = _props$sp.accessEndsAt,
      onCardClicked = props.onCardClicked;

  var onBusinessCardClicked = function onBusinessCardClicked(e) {
    e.stopPropagation();
    onCardClicked(id, proType);
  };

  var formatToLocalTime = function formatToLocalTime(utcDateTimeString) {
    var date = new Date(utcDateTimeString);
    return date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["Track"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    className: "business-card",
    id: "sp-business-card",
    onClick: onBusinessCardClicked,
    spid: id
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 7,
    md: 11,
    sm: 11,
    xs: 10
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-details"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-pills"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-source"
  }, "Angi ".concat(proType)), proType === 'Leads' && accessEndsAt && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-delegation-expiration"
  }, "Delegation expires at ".concat(formatToLocalTime(accessEndsAt)))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "h4 business-name",
    title: name
  }, name), primaryAddress ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
    className: "h4 business-region",
    title: primaryAddress.city !== undefined ? primaryAddress.city.name : ''
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-city"
  }, primaryAddress.city !== undefined ? primaryAddress.city.name : ''), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, primaryAddress.region !== undefined ? ", ".concat(primaryAddress.region.name) : '')) : null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 2,
    mdHidden: true,
    smHidden: true,
    xsHidden: true
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('business-info', {
      gray: starRating === 0
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar___default.a, {
    rating: starRating,
    starSize: "1.2em",
    ratingFontSize: "14px"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "rating-value"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "(", displayReviewCount, ")")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 2,
    mdHidden: true,
    smHidden: true,
    xsHidden: true,
    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()({
      'hide-on-hover': !usingTouchDevice
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info spid"
  }, "ID: ", id)), activityCount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 1,
    mdHidden: true,
    smHidden: true,
    xsHidden: true,
    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()({
      'hide-on-hover': !usingTouchDevice
    })
  }, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info status"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "icon icon-circle"
  })))), activityCount > 0 && (_Col || (_Col = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lgHidden: true,
    md: 1,
    sm: 1,
    xs: 2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info status"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "icon icon-circle"
  }))))), !usingTouchDevice && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 3,
    mdHidden: true,
    smHidden: true,
    xsHidden: true,
    className: "show-on-hover"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Button___default.a, {
    id: "card-select-btn",
    className: "choose-btn",
    onClick: onBusinessCardClicked
  }, "Choose")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    md: 3,
    lgHidden: true,
    sm: 4,
    xs: 6
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('business-info sm-view', {
      gray: starRating === 0
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar___default.a, {
    rating: starRating,
    starSize: "1.2em",
    ratingFontSize: "14px"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "rating-value"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "(", displayReviewCount, ")")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    md: 3,
    lgHidden: true,
    sm: 4,
    xs: 6,
    smOffset: 4
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info spid sm-view"
  }, "ID: ", id)))));
};

/* harmony default export */ __webpack_exports__["a"] = (BusinessCard);

/***/ }),

/***/ 5038:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(137);
module.exports = __webpack_require__(5039);


/***/ }),

/***/ 5039:
/***/ (function(module, exports, __webpack_require__) {

/* generated file - do not modify */
var onWindowIntl = function onWindowIntl() {
  __webpack_require__(138)(__webpack_require__(5040), [__webpack_require__(143), __webpack_require__(5164)], 'en', {
    "authorized": true,
    "deferLegalRedirect": true
  });

  var _require = __webpack_require__(98),
      addLocaleData = _require.addLocaleData;

  [__webpack_require__(144)].forEach(function (locale) {
    return addLocaleData(locale);
  });
};

var ensureFetch = function ensureFetch(cb) {
  if (typeof fetch === 'undefined') {
    __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function (require) {
      __webpack_require__(150);

      cb();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  } else {
    cb();
  }
};

var ensureIntl = function ensureIntl(cb) {
  if (typeof window.Intl === 'undefined') {
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
      __webpack_require__(55);

      __webpack_require__(56);

      cb();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  } else {
    cb();
  }
}; // Check window.Intl, then check window.fetch, then load


ensureIntl(function () {
  ensureFetch(onWindowIntl);
});

/***/ }),

/***/ 5040:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_IndexRoute__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_IndexRoute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_IndexRoute__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_browser_App__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__homeIon_scss__ = __webpack_require__(5041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__homeIon_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__homeIon_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WelcomeView__ = __webpack_require__(5042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BusinessView__ = __webpack_require__(5066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WelcomeDownloadView__ = __webpack_require__(5107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PerformanceView__ = __webpack_require__(5109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FAQView__ = __webpack_require__(5115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CallLog__ = __webpack_require__(5118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BusinessListFeatureFlaggedPage__ = __webpack_require__(5121);
var _Route;














function createRoutes() {
  return _Route || (_Route = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_4__app_browser_App__["a" /* default */],
    path: "/"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_IndexRoute___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_12__BusinessListFeatureFlaggedPage__["a" /* default */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_12__BusinessListFeatureFlaggedPage__["a" /* default */],
    path: "/home"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_12__BusinessListFeatureFlaggedPage__["a" /* default */],
    path: "/app/home"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_7__BusinessView__["a" /* default */],
    path: "/app/home/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_9__PerformanceView__["a" /* default */],
    path: "/app/performance/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_10__FAQView__["a" /* default */],
    path: "/app/performanceFAQ/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_6__WelcomeView__["a" /* default */],
    path: "/app/welcome/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_8__WelcomeDownloadView__["a" /* default */],
    path: "/app/welcome/:serviceProviderId/download-app"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_11__CallLog__["a" /* default */],
    path: "/app/callLog/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser__["OfficeNotFoundView"],
    path: "*"
  })));
}

/***/ }),

/***/ 5041:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5042:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WelcomeViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_app_platform_lib_browser_wizard__ = __webpack_require__(2330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_app_platform_lib_browser_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angieslist_app_platform_lib_browser_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_helmet_async__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_query_string__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__welcome_scss__ = __webpack_require__(5049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__welcome_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__welcome_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_BusinessDescriptionForm__ = __webpack_require__(5050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_ServiceCategoriesForm__ = __webpack_require__(5055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__app_browser_service_areas_ServiceAreaMap__ = __webpack_require__(2333);








var _Helmet, _span;

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}
















var headers = [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
  key: "pageHeader"
}, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h1", {
  className: "h4"
}, "Your Business Description")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
  key: "pageHeader"
}, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h1", {
  className: "h4"
}, "Your Service Categories")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
  key: "pageHeader"
}, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h1", {
  className: "h4"
}, "Your Service Area"))];
/* eslint react/prefer-stateless-function: 0 */

var WelcomeViewComponent = /*#__PURE__*/function (_React$Component) {
  function WelcomeViewComponent() {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, WelcomeViewComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper(this, WelcomeViewComponent, [].concat(args));

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "props", void 0);

    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(WelcomeViewComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(WelcomeViewComponent, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          serviceProviderCache = _this$props.serviceProviderCache,
          serviceProviderId = _this$props.params.serviceProviderId,
          location = _this$props.location;

      var serviceProviderLocation = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(serviceProviderCache, "".concat(serviceProviderId, ".primaryAddress.location"), {
        // default to Indianapolis
        lon: -86.1581,
        lat: 39.7684
      });

      var step = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_16_query_string___default.a.parse(location.search), 'step', '1');

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid___default.a, null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_helmet_async___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("title", null, "Welcome"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_17_classnames___default()({
          'service-area-step': step === '3'
        })
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_angieslist_app_platform_lib_browser_wizard__["WizardComponent"], {
        router: this.context.router,
        id: "welcome--wizard",
        bsStyle: "primary-office",
        headers: headers,
        submitButtonContent: _span || (_span = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span", {
          className: "wizard-button"
        }, "Done")),
        onFinalSubmit: function onFinalSubmit() {
          _this3.context.router.push({
            pathname: "/app/welcome/".concat(serviceProviderId, "/download-app")
          });
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_BusinessDescriptionForm__["a" /* default */], {
        serviceProviderId: serviceProviderId,
        key: "BusinessDescription"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_ServiceCategoriesForm__["a" /* default */], {
        serviceProviderId: serviceProviderId,
        key: "ServiceCategories"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__app_browser_service_areas_ServiceAreaMap__["a" /* default */], {
        serviceProviderId: serviceProviderId,
        advertisingArea: [],
        serviceArea: [],
        serviceProviderLocation: serviceProviderLocation,
        showEditControls: false,
        key: "ServiceAreas"
      }))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
WelcomeViewComponent.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_10_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["connect"])(function (state) {
  return {
    serviceProviderCache: state.serviceProviderCache
  };
}), __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default.a)(WelcomeViewComponent));

/***/ }),

/***/ 5049:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BusinessDescriptionFormComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_form__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform_lib_browser_forms__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform_lib_browser_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform_lib_browser_forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__businessDescriptionValidationRules__ = __webpack_require__(5051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__businessDescriptionAnalytics__ = __webpack_require__(5052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_welcomeActions__ = __webpack_require__(5053);








var _Row, _Row2;

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}















var styles = {
  descriptionTextArea: {
    minHeight: 225
  }
};
/* eslint react/prefer-stateless-function: 0 */

var BusinessDescriptionFormComponent = /*#__PURE__*/function (_React$Component) {
  function BusinessDescriptionFormComponent(props) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, BusinessDescriptionFormComponent);

    _this2 = _callSuper(this, BusinessDescriptionFormComponent, [props]);

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "props", void 0);

    // Need to explicitly define this as a function; method notation causes flow errors
    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "updateBusinessDescriptionAndTrack", function (values) {
      var _this2$props = _this2.props,
          serviceProviderId = _this2$props.serviceProviderId,
          updateBusinessDescription = _this2$props.updateBusinessDescription;
      return updateBusinessDescription(serviceProviderId, values.businessDescription).then(function () {
        __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["tracker"].track('Item Clicked', {
          serviceProviderId: serviceProviderId,
          description: 'Welcome Business Description',
          activityLocation: 'SP : Welcome Business Description',
          userId: __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(_this2, 'props.user.userInfo.response.userId')
        });
      })["catch"](function () {
        var errorMessage = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span", null, "There was a problem updating your business description.  Please contact us at ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("a", {
          id: "welcome-view--add-business-description--error-link",
          href: __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["urlCatalog"].global.businessCenterPhone()
        }, __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["urlCatalog"].global.businessCenterPhoneText()), " for assistance.");
        throw new __WEBPACK_IMPORTED_MODULE_14_redux_form__["SubmissionError"]({
          _error: errorMessage
        });
      });
    });

    _this2.updateBusinessDescriptionAndTrack = _this2.updateBusinessDescriptionAndTrack.bind(_this2);
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(BusinessDescriptionFormComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(BusinessDescriptionFormComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          error = _this$props.error,
          welcomeStore = _this$props.welcomeStore;

      var isLoading = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(welcomeStore, 'updateBusinessDescription.isLoading');

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_redux_form__["Form"], {
        onSubmit: handleSubmit(this.updateBusinessDescriptionAndTrack)
      }, error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger"
      }, error) : null, _Row || (_Row = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h5", null, "Your business description is one of the first things a member sees about your business. Include a clear, detailed overview of your business:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("ul", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, "Start with your specialties and overview of services."), " This helps the member decide quickly if you can do their job."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, "State your value proposition."), " What makes you stand out from your competitors?"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, "Sell your background and staff."), " How long have you been in business or in this line of work? Are you owner-operated or a large business?"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, "Avoid using terms that are specific to your industry."), " Potential customers may not be familiar with these."))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform_lib_browser_Loader___default.a, {
        loading: isLoading,
        element: _Row2 || (_Row2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row___default.a, {
          className: "category-row text-center"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("i", {
          className: "icon icon-load icon-spin icon-3x text-primary"
        })))
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_redux_form__["Field"], {
        name: "businessDescription",
        id: "welcome-wizard--business-description",
        component: __WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform_lib_browser_forms__["InputField"],
        type: "textarea",
        style: styles.descriptionTextArea,
        autoFocus: true
      }))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_14_redux_form__["reduxForm"])({
  form: 'welcomeBusinessDescriptionForm',
  validate: function validate(values) {
    return __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["validation"].validate(values, __WEBPACK_IMPORTED_MODULE_18__businessDescriptionValidationRules__["a" /* default */]).invalidAttrs;
  },
  destroyOnUnmount: false
}), Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["connect"])(function (state) {
  return {
    welcomeStore: state.welcome,
    user: state.user
  };
}, __WEBPACK_IMPORTED_MODULE_20__common_welcomeActions__), Object(__WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["analytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_19__businessDescriptionAnalytics__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_9_recompose_pure___default.a)(BusinessDescriptionFormComponent));

/***/ }),

/***/ 5051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  businessDescription: {
    required: true,
    minLength: 10,
    maxLength: 2000,
    textArea: true
  }
});

/***/ }),

/***/ 5052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_browser_analyticsDefaultProperties__ = __webpack_require__(42);

/* harmony default export */ __webpack_exports__["a"] = ({
  identify: {},
  page: {
    name: 'SP : Welcome Business Description',
    properties: __WEBPACK_IMPORTED_MODULE_0__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
});

/***/ }),

/***/ 5053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateBusinessDescription", function() { return updateBusinessDescription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__welcomeActionKeys__ = __webpack_require__(2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__welcomeService__ = __webpack_require__(5054);



var updateBusinessDescription = function updateBusinessDescription(serviceProviderId, businessDescription) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__welcomeActionKeys__["a" /* default */].UPDATE_BUSINESS_DESCRIPTION,
    payload: __WEBPACK_IMPORTED_MODULE_1__welcomeService__["a" /* updateBusinessDescription */](serviceProviderId, businessDescription)
  };
};
/* eslint-disable import/prefer-default-export */




/***/ }),

/***/ 5054:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateBusinessDescription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_common_profileService__ = __webpack_require__(423);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var updateBusinessDescription = function updateBusinessDescription(serviceProviderId, description) {
  return __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["httpClient"].post("/gateway/office-home/v1/service_provider/".concat(serviceProviderId, "/profile/edit"), {
    headers: {
      'X-ANGI-CallerId': serviceProviderId
    },
    body: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_2__profile_common_profileService__["b" /* defaultUpdateRequest */]), {}, {
      description: {
        action: 'Update',
        data: description
      }
    })
  });
};
/* eslint-disable import/prefer-default-export */




/***/ }),

/***/ 5055:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ServiceCategoriesFormComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_uniqBy__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_find__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_angieslist_app_platform_lib_browser_autocomplete_categoryAutocomplete_CategoryAutocomplete__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_angieslist_app_platform_lib_browser_autocomplete_categoryAutocomplete_CategoryAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_angieslist_app_platform_lib_browser_autocomplete_categoryAutocomplete_CategoryAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_redux_form__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__serviceCategoriesAnalytics__ = __webpack_require__(5056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__app_common_categories_categoriesActions__ = __webpack_require__(1016);













var _Row, _Row2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}















var styles = {
  buttonStyle: {
    margin: '.5em',
    borderRadius: '1.5em'
  }
};

/* eslint react/prefer-stateless-function: 0 */
var ServiceCategoriesFormComponent = /*#__PURE__*/function (_React$Component) {
  function ServiceCategoriesFormComponent(props) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ServiceCategoriesFormComponent);

    _this2 = _callSuper(this, ServiceCategoriesFormComponent, [props]);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_this2, "state", void 0);

    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_this2, "props", void 0);

    // Need to explicitly define this as a function; method notation causes flow errors
    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_this2, "addServiceCategories", function () {
      var _this2$props = _this2.props,
          serviceProviderId = _this2$props.serviceProviderId,
          addCategoriesToServiceProvider = _this2$props.addCategoriesToServiceProvider;
      return addCategoriesToServiceProvider(serviceProviderId, _this2.state.categoriesToAdd).then(function () {
        __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["tracker"].track('Item Clicked', {
          serviceProviderId: serviceProviderId,
          description: 'Welcome Service Categories',
          activityLocation: 'SP : Welcome Service Categories',
          userId: __WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_this2, 'props.user.userInfo.response.userId')
        });
      })["catch"](function () {
        var errorMessage = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("span", null, "There was a problem adding service categories.  Please contact us at ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("a", {
          id: "welcome-view--add-service-categories--error-link",
          href: __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["urlCatalog"].global.businessCenterPhone()
        }, __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["urlCatalog"].global.businessCenterPhoneText()), " for assistance.");
        throw new __WEBPACK_IMPORTED_MODULE_22_redux_form__["SubmissionError"]({
          _error: errorMessage
        });
      });
    });

    _this2.addServiceCategories = _this2.addServiceCategories.bind(_this2);
    _this2.state = {
      categoriesToAdd: []
    };
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ServiceCategoriesFormComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ServiceCategoriesFormComponent, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          getServiceProviderCategories = _this$props.getServiceProviderCategories,
          serviceProviderId = _this$props.serviceProviderId;
      getServiceProviderCategories(serviceProviderId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          handleSubmit = _this$props2.handleSubmit,
          error = _this$props2.error,
          welcomeStore = _this$props2.welcomeStore;

      var isLoading = __WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(welcomeStore, 'categoriesToAdd.isLoading');

      var currentCategories = __WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(welcomeStore, 'serviceProviderCategories.response.categories');

      var categoryAutocompleteProps = {
        id: 'welcome-service-categories--add-category-autocomplete',
        placeholder: 'Start typing and select a category',
        autoFocus: false,
        iconLocation: 'none',
        requireSelection: true,
        clearAfterSelection: true,
        autocompleteEventHandler: function autocompleteEventHandler(event) {
          var newCategory = {
            name: event.displayText,
            id: event.categoryId
          };

          if (__WEBPACK_IMPORTED_MODULE_10_lodash_find___default()(currentCategories, {
            id: event.categoryId
          })) {
            _this3.setState({
              error: 'This category has already been added to your profile.'
            });
          } else {
            _this3.setState({
              categoriesToAdd: __WEBPACK_IMPORTED_MODULE_9_lodash_uniqBy___default()([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this3.state.categoriesToAdd), [newCategory]), 'id'),
              error: ''
            });
          }
        }
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_redux_form__["Form"], {
        onSubmit: handleSubmit(this.addServiceCategories)
      }, error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger"
      }, error) : null, this.state.error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger"
      }, this.state.error) : null, _Row || (_Row = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("h5", null, "Show members the services you offer"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, "Let us know what other services you offer in addition to the service category listed below.")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_angieslist_app_platform_lib_browser_Loader___default.a, {
        loading: isLoading,
        element: _Row2 || (_Row2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row___default.a, {
          className: "category-row text-center"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("i", {
          className: "icon icon-load icon-spin icon-3x text-primary"
        })))
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_angieslist_app_platform_lib_browser_autocomplete_categoryAutocomplete_CategoryAutocomplete___default.a, {
        categoryAutocompleteDetails: categoryAutocompleteProps
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(currentCategories, function (category) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button___default.a, {
          className: "existing-category",
          style: styles.buttonStyle,
          key: category.id,
          id: "category-management--add-category--existing-category-".concat(category.id),
          bsStyle: "primary-office",
          bsSize: "xsmall",
          flat: true,
          disabled: true
        }, category.name);
      }), __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(this.state.categoriesToAdd, function (category) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button___default.a, {
          className: "new-category",
          style: styles.buttonStyle,
          key: category.id,
          id: "category-management--add-category--new-category-".concat(category.id),
          bsStyle: "primary-office",
          bsSize: "xsmall",
          flat: true,
          onClick: function onClick() {
            _this3.setState({
              categoriesToAdd: __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(_this3.state.categoriesToAdd, function (c) {
                return c.id !== category.id;
              }),
              error: ''
            });
          }
        }, category.name, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("i", {
          className: "icon icon-close",
          style: {
            marginLeft: '0.7em'
          }
        }));
      })))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_22_redux_form__["reduxForm"])({
  form: 'welcomeServiceCategoriesForm',
  destroyOnUnmount: false
}), Object(__WEBPACK_IMPORTED_MODULE_23_react_redux__["connect"])(function (state) {
  return {
    welcomeStore: state.welcome,
    user: state.user
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_25__app_common_categories_categoriesActions__)), Object(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["analytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_24__serviceCategoriesAnalytics__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_14_recompose_pure___default.a)(ServiceCategoriesFormComponent));

/***/ }),

/***/ 5056:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_browser_analyticsDefaultProperties__ = __webpack_require__(42);

/* harmony default export */ __webpack_exports__["a"] = ({
  identify: {},
  page: {
    name: 'SP : Welcome Service Categories',
    properties: __WEBPACK_IMPORTED_MODULE_0__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
});

/***/ }),

/***/ 5066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export BusinessViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet_async__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_browser_analyticsDefaultProperties__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ServiceProviderDashboard__ = __webpack_require__(2335);
var _Helmet;











var loader = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
  className: "text-center"
}, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
  className: "icon icon-load icon-spin icon-5x text-primary"
}));
var BusinessViewComponent = function BusinessViewComponent(_ref) {
  var serviceProviderCache = _ref.serviceProviderCache,
      params = _ref.params,
      experiment = _ref.experiment;
  var serviceProviderId = params.serviceProviderId;
  var serviceProvider = serviceProviderCache[serviceProviderId];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet_async___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, "Dashboard"))), !serviceProvider || typeof serviceProvider.isAdvertiser === 'undefined' ? loader : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ServiceProviderDashboard__["a" /* default */], {
    serviceProvider: serviceProvider
  }));
};
var businessViewAnalytics = {
  page: {
    name: 'SP : Home',
    properties: __WEBPACK_IMPORTED_MODULE_7__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__["analytics"])({
  ruleset: businessViewAnalytics
}), Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    serviceProviderCache: state.serviceProviderCache,
    experiment: state.experimentV2
  };
}, __WEBPACK_IMPORTED_MODULE_8__app_common_serviceProvider_serviceProviderActions__["default"]), __WEBPACK_IMPORTED_MODULE_2_recompose_pure___default.a)(BusinessViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5107:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export WelcomeDownloadViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_browser_download_DownloadPrompt__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__welcomeDownloadAnalytics__ = __webpack_require__(5108);








var WelcomeDownloadViewComponent = function WelcomeDownloadViewComponent(props) {
  var serviceProviderId = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(props, 'params.serviceProviderId');

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__app_browser_download_DownloadPrompt__["a" /* default */], {
    header: "Download Our Pro Ads Mobile App",
    subheader: "Our best Angi Pro Ads experience, designed with you in mind.",
    showEscapeLink: true,
    serviceProviderId: serviceProviderId,
    referrer: "OfficeOnboardFunnel"
  });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_5_angieslist_app_platform__["legacyAnalytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_7__welcomeDownloadAnalytics__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default.a)(WelcomeDownloadViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__ = __webpack_require__(42);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var activityLocation = 'SP : Welcome App Download';
/* harmony default export */ __webpack_exports__["a"] = ({
  identify: {},
  page: {
    name: activityLocation,
    properties: __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  },
  elements: {
    'app-download--link-android': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["c" /* defaultProps */]), {}, {
          description: 'Android Pro App',
          activityLocation: activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>'
        })
      }
    },
    'app-download--link-ios': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["c" /* defaultProps */]), {}, {
          description: 'iOS Pro App',
          activityLocation: activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>'
        })
      }
    },
    'app-download--escape-link': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["c" /* defaultProps */]), {}, {
          description: 'No Thanks',
          activityLocation: activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>'
        })
      }
    },
    'app-download--send-sms-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["c" /* defaultProps */]), {}, {
          description: 'Welcome Send Link',
          activityLocation: activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>'
        })
      }
    }
  }
});

/***/ }),

/***/ 5109:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export PerformanceViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_sortBy__ = __webpack_require__(2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet_async__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_hot_loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Grid__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Alert__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_CategoryGroupMetrics__ = __webpack_require__(5110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_PerformanceViewHeader__ = __webpack_require__(5112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_performanceActions__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PerformanceView_scss__ = __webpack_require__(5114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PerformanceView_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__PerformanceView_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_app_browser_analyticsDefaultProperties__ = __webpack_require__(42);









var _Helmet, _Row, _i, _Col;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}


















var PerformanceViewComponent = /*#__PURE__*/function (_React$Component) {
  function PerformanceViewComponent() {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, PerformanceViewComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper(this, PerformanceViewComponent, [].concat(args));

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "props", void 0);

    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(PerformanceViewComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(PerformanceViewComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var params = this.props.params;

      var serviceProviderId = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(params, 'serviceProviderId');

      var endTime = new Date();
      var startTime = new Date(new Date().setDate(endTime.getDate() - 90));
      this.props.getContactMetricsCategoryGroupsByServiceProvider({
        serviceProviderId: serviceProviderId,
        startTime: startTime,
        endTime: endTime
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$performan = _this$props.performance.contactMetricsByCategory,
          contactMetricsByCategoryResponse = _this$props$performan.response,
          contactMetricsByCategoryLoading = _this$props$performan.isLoading,
          contactMetricsByCategoryError = _this$props$performan.error,
          params = _this$props.params;

      var serviceProviderId = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(params, 'serviceProviderId');

      var categoryData = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(contactMetricsByCategoryResponse, 'categoryGroupMetrics'); // Prioritize advertising categories at the top


      var categoryDataSorted = __WEBPACK_IMPORTED_MODULE_6_lodash_sortBy___default()(categoryData, function (c) {
        return c.categoryGroup.hasAdvertisingIn;
      }).reverse();

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        id: "performance-view--".concat(serviceProviderId),
        className: "performance-view-wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Grid___default.a, null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_helmet_async___default.a, {
        title: "Performance"
      })), _Row || (_Row = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 9
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h1", null, "Performance")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 3,
        className: "last-90-days-header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "Last 90 days")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform_lib_browser_Loader___default.a, {
        loading: contactMetricsByCategoryLoading,
        element: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, {
          className: "category-row text-center",
          style: {
            marginTop: '1em'
          }
        }, _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("i", {
          className: "icon icon-load icon-spin icon-3x text-primary"
        })))
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        className: "performance-page-header",
        xs: 12
      }, contactMetricsByCategoryError ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger"
      }, "There was a problem retrieving your performance metrics. Please contact us at\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a", {
        id: "service-areas--add-service-area--store-error-link",
        href: __WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__["urlCatalog"].global.businessCenterPhone(),
        style: {
          whiteSpace: 'nowrap'
        }
      }, __WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__["urlCatalog"].global.businessCenterPhoneText()), " for assistance.") : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_PerformanceViewHeader__["a" /* default */], {
        serviceProviderId: serviceProviderId,
        contactMetrics: contactMetricsByCategoryResponse,
        isAdvertiser: true
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", {
        style: {
          marginBottom: '0.8em'
        }
      }, "Breakdown by Category Groups"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, null, _Col || (_Col = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 12,
        md: 4
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: "calls-explanation"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "How we know about phone calls"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Customers are required to click to reveal your phone number, and this lets us know what categories they are likely contacting you about. This data helps us estimate what categories your calls were about.")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 12,
        md: 8
      }, categoryDataSorted ? categoryDataSorted.map(function (singleCategoryMetric) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_CategoryGroupMetrics__["a" /* default */], {
          key: singleCategoryMetric.categoryGroup.name,
          singleCategoryMetric: singleCategoryMetric,
          serviceProviderId: serviceProviderId,
          isAdvertiser: true
        });
      }) : null)))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
var performanceAnalytics = {
  page: {
    name: 'SP : Performance',
    properties: __WEBPACK_IMPORTED_MODULE_24__src_app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_10_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__["analytics"])({
  ruleset: performanceAnalytics
}), Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["connect"])(function (state) {
  return {
    user: state.user,
    performance: state.performance
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_22__common_performanceActions__["a" /* default */])), __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default.a)(PerformanceViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export CategoryGroupMetricsComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_sum__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_last__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_hot_loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CustomerContactsChart__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__app_common_advertise_advertiseActions__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CategoryGroupMetrics_scss__ = __webpack_require__(5111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CategoryGroupMetrics_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__CategoryGroupMetrics_scss__);











var _div, _Col;

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}













var isLastItem = function isLastItem(currentItem, subCategoryCollection) {
  return currentItem === __WEBPACK_IMPORTED_MODULE_8_lodash_last___default()(subCategoryCollection);
};

var calculateContactsPercentage = function calculateContactsPercentage(contactCount, contactTotal) {
  return contactCount / contactTotal * 100;
};

var trackCategory = function trackCategory(segmentDataCollection) {
  __WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform__["tracker"].track('Item Displayed', {
    activityLocation: 'SP : Performance',
    contactCountDisplayed: segmentDataCollection.contactCountDisplayed,
    categoryGroupId: segmentDataCollection.categoryGroupId,
    description: segmentDataCollection.hasAdvertisingIn ? 'Advertising Category Group Contacts' : 'NonAdvertising Category Group Contacts',
    serviceProviderId: segmentDataCollection.serviceProviderId,
    userId: segmentDataCollection.userId
  });
};

var CategoryGroupMetricsComponent = /*#__PURE__*/function (_React$Component) {
  function CategoryGroupMetricsComponent() {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CategoryGroupMetricsComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper(this, CategoryGroupMetricsComponent, [].concat(args));

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "props", void 0);

    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(CategoryGroupMetricsComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CategoryGroupMetricsComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          serviceProviderId = _this$props.serviceProviderId,
          _this$props$singleCat = _this$props.singleCategoryMetric,
          aggregatedContactCount = _this$props$singleCat.aggregatedContactCount,
          _this$props$singleCat2 = _this$props$singleCat.categoryGroup,
          categoryGroupId = _this$props$singleCat2.categoryGroupId,
          hasAdvertisingIn = _this$props$singleCat2.hasAdvertisingIn,
          user = _this$props.user;
      var segmentDataCollection = {
        serviceProviderId: serviceProviderId,
        categoryGroupId: categoryGroupId,
        contactCountDisplayed: aggregatedContactCount,
        hasAdvertisingIn: hasAdvertisingIn,
        userId: user.userInfo.response.userId
      };
      trackCategory(segmentDataCollection);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          singleCategoryMetric = _this$props2.singleCategoryMetric,
          serviceProviderId = _this$props2.serviceProviderId;
      var subCategoryCollection = singleCategoryMetric.categoryGroup.categories;

      var typeMetrics = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(singleCategoryMetric, 'contactTypeMetrics', []);

      var callsMetrics = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'Calls';
      });

      var estimatedCallsMetrics = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'Estimated Calls';
      });

      var quotesMetrics = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'RequestAQuote';
      });

      var messagesMetrics = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'MessageSent';
      });

      var dealsMetrics = __WEBPACK_IMPORTED_MODULE_7_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'DealClaimed';
      });

      var callCount = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(callsMetrics, 'contactCount', 0);

      var estimatedCallCount = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(estimatedCallsMetrics, 'contactCount', 0);

      var quoteRequestsCount = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(quotesMetrics, 'contactCount', 0);

      var messagesCount = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(messagesMetrics, 'contactCount', 0);

      var claimedDealsCount = __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(dealsMetrics, 'contactCount', 0);

      var totalCount = __WEBPACK_IMPORTED_MODULE_6_lodash_sum___default()([callCount, estimatedCallCount, quoteRequestsCount, messagesCount, claimedDealsCount]); // Category Specific Advertise With Us Upsell


      var isAdvertiserInCategory = singleCategoryMetric.categoryGroup.hasAdvertisingIn;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
        className: "category-group-metrics--wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
        className: "category-group-component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default.a, {
        className: "category-group-component-header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        sm: 2,
        className: "category-group-component-sub-header hidden-xs"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
        className: "category-group-component-total-contacts-number"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h2", null, singleCategoryMetric.aggregatedContactCount)), _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
        className: "category-group-component-total-contacts-subtitle"
      }, "Contacts"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        className: "category-group-component-sub-header visible-xs"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("h3", {
        style: {
          marginLeft: '.4em',
          marginTop: 0
        }
      }, singleCategoryMetric.aggregatedContactCount, " Contacts")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        sm: 10,
        className: "category-group-component-category-info"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("div", {
        style: {
          fontWeight: 'bold'
        }
      }, singleCategoryMetric.categoryGroup.name, isAdvertiserInCategory ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement("span", {
        style: {
          fontWeight: 'normal',
          fontStyle: 'italic'
        }
      }, "\xA0(Advertising)") : null), subCategoryCollection.map(function (subCategoryItem) {
        return isLastItem(subCategoryItem, subCategoryCollection) ? "".concat(subCategoryItem.name) : "".concat(subCategoryItem.name, ", ");
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default.a, null, _Col || (_Col = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        xs: 0,
        sm: 2
      }, "\xA0")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        xs: 12,
        sm: 10,
        className: "category-group-component-metrics"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__CustomerContactsChart__["a" /* default */], {
        totalToDisplay: singleCategoryMetric ? singleCategoryMetric.aggregatedContactCount : 0,
        callsPercentage: calculateContactsPercentage(callCount + estimatedCallCount, totalCount),
        trackedCallsPercentage: calculateContactsPercentage(callCount, callCount + estimatedCallCount),
        quoteRequestsPercentage: calculateContactsPercentage(quoteRequestsCount, totalCount),
        messagesPercentage: calculateContactsPercentage(messagesCount, totalCount),
        claimedDealsPercentage: calculateContactsPercentage(claimedDealsCount, totalCount),
        strokeWidth: 4,
        serviceProviderId: serviceProviderId,
        isAdvertiser: true
      })))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_11_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["connect"])(function (state) {
  return {
    advertise: state.advertise,
    user: state.user
  };
}, __WEBPACK_IMPORTED_MODULE_19__app_common_advertise_advertiseActions__), __WEBPACK_IMPORTED_MODULE_12_recompose_pure___default.a)(CategoryGroupMetricsComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5112:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sum__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomerContactsChart__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PerformanceViewHeader_scss__ = __webpack_require__(5113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PerformanceViewHeader_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__PerformanceViewHeader_scss__);




var _h, _div, _strong, _br, _div2;










var calculateContactsPercentage = function calculateContactsPercentage(contactCount, contactTotal) {
  return contactTotal > 0 ? contactCount / contactTotal * 100 : 0;
};

var PerformanceViewHeaderComponent = function PerformanceViewHeaderComponent(PerformanceViewHeaderProps) {
  var serviceProviderId = PerformanceViewHeaderProps.serviceProviderId,
      contactMetrics = PerformanceViewHeaderProps.contactMetrics,
      isAdvertiser = PerformanceViewHeaderProps.isAdvertiser;

  var typeMetrics = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(contactMetrics, 'contactTypeMetrics', {});

  var callsMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'Calls';
  });

  var estimatedCallsMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'Estimated Calls';
  });

  var quotesMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'RequestAQuote';
  });

  var messagesMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'MessageSent';
  });

  var dealsMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'DealClaimed';
  });

  var callCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(callsMetrics, 'contactCount', 0);

  var estimatedCallCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(estimatedCallsMetrics, 'contactCount', 0);

  var quoteRequestsCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(quotesMetrics, 'contactCount', 0);

  var messagesCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(messagesMetrics, 'contactCount', 0);

  var claimedDealsCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(dealsMetrics, 'contactCount', 0);

  var totalCount = __WEBPACK_IMPORTED_MODULE_0_lodash_sum___default()([callCount, estimatedCallCount, quoteRequestsCount, messagesCount, claimedDealsCount]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    id: "performance-view-header-".concat(serviceProviderId),
    className: "performance-view-header-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    sm: 3,
    className: "performance-view-header-section contacts"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "contact-box"
  }, _h || (_h = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h4", null, "Customer Contacts")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h1", null, contactMetrics ? contactMetrics.aggregatedContactCount : 0), _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "last-90-days"
  }, "Last 90 days")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    sm: 6,
    className: "performance-view-header-section chart"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CustomerContactsChart__["a" /* default */], {
    totalToDisplay: contactMetrics ? contactMetrics.aggregatedContactCount : 0,
    callsPercentage: calculateContactsPercentage(callCount + estimatedCallCount, totalCount),
    trackedCallsPercentage: calculateContactsPercentage(callCount, callCount + estimatedCallCount),
    quoteRequestsPercentage: calculateContactsPercentage(quoteRequestsCount, totalCount),
    messagesPercentage: calculateContactsPercentage(messagesCount, totalCount),
    claimedDealsPercentage: calculateContactsPercentage(claimedDealsCount, totalCount),
    strokeWidth: 7,
    serviceProviderId: serviceProviderId,
    isAdvertiser: isAdvertiser
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    sm: 3,
    className: "performance-view-header-section misc"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "pro-tip"
  }, _strong || (_strong = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("strong", null, "Pro Tip: ")), " Refine your service area to get requests in the areas you want. ", _br || (_br = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("br", null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a", {
    id: "add-service-areas-link",
    href: __WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform__["urlCatalog"].office.spProfile.serviceAreas(serviceProviderId)
  }, "Add Service Areas")), _div2 || (_div2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "calls-explanation"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("strong", null, "How we know about phone calls"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("p", null, "Customers are required to click to reveal your phone number, and this lets us know what categories they are likely contacting you about. This data helps us estimate what categories your calls were about."))))));
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_5_recompose_pure___default.a)(PerformanceViewHeaderComponent));

/***/ }),

/***/ 5113:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5115:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export FAQViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_hot_loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_helmet_async__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FAQAnalytics__ = __webpack_require__(5116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__faqView_scss__ = __webpack_require__(5117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__faqView_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__faqView_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_performanceActions__ = __webpack_require__(1020);









var _Helmet, _h, _h2, _p, _h3, _p2, _p3, _h4, _em, _p4, _h5, _h6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}














var FAQViewComponent = /*#__PURE__*/function (_React$Component) {
  function FAQViewComponent() {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, FAQViewComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper(this, FAQViewComponent, [].concat(args));

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "props", void 0);

    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(FAQViewComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(FAQViewComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var endTime = new Date();
      var startTime = new Date(new Date().setDate(endTime.getDate() - 90));
      var serviceProviderId = this.props.params.serviceProviderId;
      var getContactMetricsByServiceProvider = this.props.getContactMetricsByServiceProvider;
      getContactMetricsByServiceProvider({
        serviceProviderId: serviceProviderId,
        startTime: startTime,
        endTime: endTime
      });
      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          serviceProviderCache = _this$props.serviceProviderCache,
          contactMetrics = _this$props.performance.contactMetrics.response;

      var typeMetrics = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(contactMetrics, 'contactTypeMetrics', {});

      var callsMetrics = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'Calls';
      });

      var estimatedCallsMetrics = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'Estimated Calls';
      });

      var callCount = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(callsMetrics, 'contactCount', 0);

      var estimatedCallCount = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(estimatedCallsMetrics, 'contactCount', 0);

      var totalCallCount = callCount + estimatedCallCount;
      var trackedCallPercentage = Math.round(totalCallCount > 0 ? callCount / totalCallCount * 100 : 0);
      var params = this.props.params;

      var serviceProviderId = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(params, 'serviceProviderId');

      var currentSP = serviceProviderCache[serviceProviderId];

      var isAdvertiser = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(currentSP, 'isAdvertiser', false);

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        style: {
          marginTop: '-1.25em'
        },
        className: "faq-container"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid___default.a, null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_helmet_async___default.a, {
        title: "Performance FAQ"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, _h || (_h = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h1", null, "Performance Metrics")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", {
        style: {
          marginBottom: '1.5em'
        }
      }, "Frequently Asked Questions"), _h2 || (_h2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", null, "What are Customer Contacts?")), _p || (_p = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "overall"), " Customer Contacts metric represents the total count of contacts the registered business received over the designated time period minus any duplicate contacts sent by the same customer on the same day. If the same customer contacts the business twice in one day, Customer Contacts will only increase by one for that interaction. For example, if the same customer submits a Request a Quote and then calls through Angi on the same day for your business, Angi will only count the pair of contacts as a single Customer Contact. Messages in Message center are a means to communicate with customers who Request a Quote or Claim a Deal and each individual message does not count as a unique contact.")), isAdvertiser ? [_h3 || (_h3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", {
        key: "0"
      }, "What are category Customer Contacts?")), _p2 || (_p2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", {
        key: "1"
      }, "On the \"Performance\" page, you'll see a more detailed breakdown of your Customer Contacts. The number of Customer Contacts in a category group represents the total unique customers by day that contact your business over the time period ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "in a specific category group"), ". The same deduplication rules apply, but only for contacts in the same category group. If one customer contacts you for two or more category groups in one day, that customer will be counted uniquely in each ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "specific category group"), ", but only as one ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "overall"), "\xA0Customer Contact."))] : null, _p3 || (_p3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Around the Customer Contacts numbers, you'll see a donut graph. This represents the contact method distribution. You can use this to see how your customers have chosen to contact your business through the methods described below.")), isAdvertiser ? [_h4 || (_h4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", {
        key: "0"
      }, "What are Estimated Calls?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", {
        key: "1"
      }, "We can attribute most member phone calls to Angi Certified Pros due to our tracked phone numbers. However, some members contact Certified Pros outside our platform in a way we cannot directly track. Over a third of Angi members we sampled use the site to confirm recommendations from friends, neighbors, or family members, so they might already have your phone number. After a thorough analysis of our nationwide site traffic and reviews left without trackable contacts over the past year, we estimate on average how frequently this occurs.", totalCallCount > 0 ? [" Of the calls metric shown, ", trackedCallPercentage, "% are due to tracked phone calls. The remainder are from phone calls we believe happened off of our platform."] : null), _em || (_em = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", {
        key: "2"
      }, "How are calls assigned a category?")), _p4 || (_p4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", {
        key: "3"
      }, "Angi members are required to click to reveal your phone number, and this lets us know what categories they are likely to be contacting your business about. We use this data to estimate what categories your calls were about."))] : null, _h5 || (_h5 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", null, "What are Quote Requests?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Throughout our site, Angi members can click on 'Request a Quote' buttons that lead them down a multistep funnel that asks them several questions about their project and requires them to send their phone number and email address. These are shown on the\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a", {
        id: "performance-faq--what-are-requests-lead",
        href: __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__["urlCatalog"].office.leadBoard(serviceProviderId)
      }, "Lead Board"), "\xA0and are labeled \"Quote Request.\""), _h6 || (_h6 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", null, "What are Claimed Deals?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "We show Angi members available deals to claim in a variety of places on our site including the 'Shop Deals' section and the featured spots on the top of search results. Your Client Success Manager can help you set up a Deal if you don\u2019t currently have one. These are shown on the\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a", {
        id: "performance-faq--what-are-deals-lead",
        href: __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__["urlCatalog"].office.leadBoard(serviceProviderId)
      }, "Lead Board"), "\xA0and are labeled \"Claimed Deal.\"")))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_10_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__["analytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_18__FAQAnalytics__["a" /* default */]
}), Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(function (state) {
  return {
    performance: state.performance,
    serviceProviderCache: state.serviceProviderCache
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_20__common_performanceActions__["a" /* default */])), __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default.a)(FAQViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsHelpers__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_browser_analyticsDefaultProperties__ = __webpack_require__(42);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* harmony default export */ __webpack_exports__["a"] = ({
  identify: {},
  page: {
    name: 'SP : PerformanceFAQ',
    properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_2__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]), {}, {
      userType: 'Authenticated'
    })
  },
  elements: {
    'performance-faq--*': Object(__WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsHelpers__["b" /* itemClicked */])('SP : PerformanceFAQ', 'Link')
  }
});

/***/ }),

/***/ 5117:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export CallLogComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNull__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_map__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_hot_loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_EllipsedPagination__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_EllipsedPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_EllipsedPagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Grid__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Table__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_helmet_async__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_performanceActions__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__app_browser_analyticsDefaultProperties__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CallLog_scss__ = __webpack_require__(5120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CallLog_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__CallLog_scss__);










var _Helmet, _i, _thead, _p;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}



















var CallLogComponent = /*#__PURE__*/function (_React$Component) {
  function CallLogComponent(props) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CallLogComponent);

    _this2 = _callSuper(this, CallLogComponent, [props]);

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "state", void 0);

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "props", void 0);

    _this2.state = {
      pageIndex: 0
    };
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(CallLogComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CallLogComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var offset = 0;
      var numberOfEntries = 25;
      var serviceProviderId = this.props.params.serviceProviderId;
      var getCallLogByServiceProvider = this.props.getCallLogByServiceProvider;
      getCallLogByServiceProvider({
        serviceProviderId: serviceProviderId,
        offset: offset,
        numberOfEntries: numberOfEntries
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          _this$props$performan = _this$props.performance.callLog,
          callLog = _this$props$performan.response,
          isLoading = _this$props$performan.isLoading,
          getCallLogByServiceProvider = _this$props.getCallLogByServiceProvider;

      var parsedDate = function parsedDate(call) {
        var localDate = __WEBPACK_IMPORTED_MODULE_21_moment___default()(call.date);
        return {
          localDate: localDate.format('L'),
          time: call.displayTime ? localDate.format('h:mm A') : 'N/A'
        };
      };

      var pageIndex = this.state.pageIndex;
      var numberOfEntries = 25;
      var pageCount = __WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils__["getPageCount"](__WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(callLog, 'totalCalls', false), numberOfEntries);

      var callLogResponse = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(callLog, 'phoneCalls', false);

      var parsedLocalDate = __WEBPACK_IMPORTED_MODULE_7_lodash_map___default()(callLogResponse, function (call) {
        return _objectSpread(_objectSpread({}, call), {}, {
          date: parsedDate(call)
        });
      });

      var totalCalls = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(callLog, 'totalCalls', false);

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        id: "Call-Log-Container",
        style: {
          background: 'white',
          paddingTop: 0,
          marginTop: '-1.25em'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Grid___default.a, null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_helmet_async___default.a, {
        title: "Customer Call Log"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("h1", {
        style: {
          marginBottom: '.8em'
        }
      }, "Customer Call Log"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_angieslist_app_platform_lib_browser_Loader___default.a, {
        loading: isLoading,
        element: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default.a, {
          className: "category-row text-center",
          style: {
            marginTop: '1em'
          }
        }, _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("i", {
          className: "icon icon-load icon-spin icon-3x text-primary"
        })))
      }, callLogResponse && !isLoading ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Table___default.a, {
        responsive: true,
        striped: true
      }, _thead || (_thead = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("thead", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("tr", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("th", null, "Phone Number"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("th", null, "Date"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("th", null, "Time"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("th", null, "Call Duration (m:s)")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_7_lodash_map___default()(parsedLocalDate, function (entry) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("tr", {
          key: entry.date
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("td", null, entry.number), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("td", null, entry.date.localDate), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("td", null, entry.date.time), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("td", null, !entry.duration || __WEBPACK_IMPORTED_MODULE_6_lodash_isNull___default()(entry.duration) ? 'N/A' : __WEBPACK_IMPORTED_MODULE_21_moment___default()(entry.duration * 1000).format('m:ss')));
      }))) : null, totalCalls === 0 ? _p || (_p = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("p", null, "No calls available")) : null))), pageCount > 1 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_EllipsedPagination___default.a, {
        pageCount: pageCount,
        pageIndex: pageIndex,
        onChange: function onChange(i) {
          var serviceProviderId = _this3.props.params.serviceProviderId;
          var offset = __WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils__["getOffset"](i + 1, 25);
          getCallLogByServiceProvider({
            serviceProviderId: serviceProviderId,
            offset: offset,
            numberOfEntries: numberOfEntries
          });

          _this3.setState(function () {
            return {
              pageIndex: i
            };
          });

          __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["tracker"].track('Item Clicked', {
            serviceProviderId: serviceProviderId,
            description: "Page ".concat(i + 1),
            activityLocation: 'SP : Call Log',
            userId: __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(_this3, 'props.user.userInfo.response.userId')
          });
        }
      }))) : null));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
var CallLogAnalytics = {
  page: {
    name: 'SP : Customer Call Log',
    properties: __WEBPACK_IMPORTED_MODULE_25__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_11_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["analytics"])({
  ruleset: CallLogAnalytics
}), Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(function (state) {
  return {
    performance: state.performance
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_24__common_performanceActions__["a" /* default */])), __WEBPACK_IMPORTED_MODULE_12_recompose_pure___default.a)(CallLogComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5120:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BusinessListPage__ = __webpack_require__(5122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UnifiedBusinessListView__ = __webpack_require__(5158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__withBusinessListFeatureFlaggedPageConfig__ = __webpack_require__(5163);


var _i;

var _excluded = ["experiment"];

/* eslint-disable no-undef */







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_7__withBusinessListFeatureFlaggedPageConfig__["a" /* default */])(function (_ref) {
  var _experiment$experimen;

  var experiment = _ref.experiment,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser_Loader___default.a, {
    element: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Row___default.a, {
      className: "category-row text-center",
      style: {
        marginTop: '1em'
      }
    }, _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("i", {
      className: "icon icon-load icon-spin icon-3x text-primary"
    }))),
    loading: Object.keys(experiment.experiments).length === 0
  }, (_experiment$experimen = experiment.experiments) !== null && _experiment$experimen !== void 0 && (_experiment$experimen = _experiment$experimen.unifiedBusinessList) !== null && _experiment$experimen !== void 0 && _experiment$experimen.enabled ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BusinessListPage__["a" /* default */], props) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UnifiedBusinessListView__["a" /* default */], props));
}));

/***/ }),

/***/ 5122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BusinessListPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_EllipsedPagination__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_EllipsedPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_EllipsedPagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_office_app_common_lib_v1_restrictedAccess_legacyRestrictredAccess__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_office_app_common_lib_v1_restrictedAccess_legacyRestrictredAccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_office_app_common_lib_v1_restrictedAccess_legacyRestrictredAccess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_browser_home_common_Icons__ = __webpack_require__(5147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_browser_analyticsDefaultProperties__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BusinessListPage_scss__ = __webpack_require__(5148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BusinessListPage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__BusinessListPage_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_browser_home_BusinessList_components_Options__ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_browser_home_BusinessList_components_FlatList__ = __webpack_require__(5150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_browser_home_BusinessList_components_HelpFooter__ = __webpack_require__(5152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__app_browser_analyticsHelpers__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_browser_home_BusinessList_components_CategorizedList__ = __webpack_require__(5154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_browser_home_BusinessList_components_BottomDrawerModal__ = __webpack_require__(5156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_browser_home_common_BusinessListConstants__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__app_common_businessList_businessListActions__ = __webpack_require__(699);




var _div, _b, _AppraisersIcon, _i, _HelpFooter;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable import/no-named-as-default */






















var sortTypes = {
  ratings: 'Customer ratings (high to low)',
  reviews: 'Total reviews (high to low)'
};
var BusinessListPage = function BusinessListPage(_ref) {
  var businessList = _ref.businessList,
      serviceProviderCache = _ref.serviceProviderCache,
      getServiceProviders = _ref.getServiceProviders;
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    getServiceProviders({
      limit: __WEBPACK_IMPORTED_MODULE_23__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */],
      offset: __WEBPACK_IMPORTED_MODULE_23__modules_browser_home_common_BusinessListConstants__["a" /* DEFAULT_OFFSET */]
    });
  }, []); // TODO: Uncomment this when enabling Snowplow page load tracking for all pages.
  // This is currently kept as a reference for sending enhanced page view events.
  // const snowplowParams = {
  //   pageName: 'SP : Business List',
  // };
  //
  // useEnhancedPageView(snowplowParams);

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(''),
      _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      sortByValue = _useState2[0],
      setSortByValue = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),
      _useState4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
      openFilter = _useState4[0],
      setOpenFilter = _useState4[1];

  var toggleBottomFilter = function toggleBottomFilter(openFilterValue) {
    setOpenFilter(openFilterValue);
  };

  var addActivityCount = function addActivityCount(sp) {
    if (sp.proType.toLowerCase() === 'leads') {
      var _ref3 = serviceProviderCache["HA-".concat(sp.id)] || {},
          _ref2$unreadLeadCount2 = _ref3.unreadLeadCount,
          _unreadLeadCount = _ref2$unreadLeadCount2 === void 0 ? 0 : _ref2$unreadLeadCount2,
          _ref2$opportunityCoun2 = _ref3.opportunityCount,
          opportunityCount = _ref2$opportunityCoun2 === void 0 ? 0 : _ref2$opportunityCoun2;

      return _objectSpread(_objectSpread({}, sp), {}, {
        activityCount: _unreadLeadCount + opportunityCount
      });
    }

    var _ref4 = serviceProviderCache[sp.id] || {},
        _ref4$unreadLeadCount = _ref4.unreadLeadCount,
        unreadLeadCount = _ref4$unreadLeadCount === void 0 ? 0 : _ref4$unreadLeadCount,
        _ref4$unreadDealCount = _ref4.unreadDealCount,
        unreadDealCount = _ref4$unreadDealCount === void 0 ? 0 : _ref4$unreadDealCount,
        _ref4$unreadQuoteCoun = _ref4.unreadQuoteCount,
        unreadQuoteCount = _ref4$unreadQuoteCoun === void 0 ? 0 : _ref4$unreadQuoteCoun,
        _ref4$unreadReviewCou = _ref4.unreadReviewCount,
        unreadReviewCount = _ref4$unreadReviewCou === void 0 ? 0 : _ref4$unreadReviewCou,
        _ref4$unreadMessageCo = _ref4.unreadMessageCount,
        unreadMessageCount = _ref4$unreadMessageCo === void 0 ? 0 : _ref4$unreadMessageCo;

    var total = unreadLeadCount + unreadDealCount + unreadQuoteCount + unreadReviewCount + unreadMessageCount;
    return _objectSpread(_objectSpread({}, sp), {}, {
      activityCount: total
    });
  };

  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(businessList, 'getServiceProviders.response') || {},
      _ref5$sortedBy = _ref5.sortedBy,
      sortedBy = _ref5$sortedBy === void 0 ? '' : _ref5$sortedBy,
      _ref5$serviceProvider = _ref5.serviceProviders,
      serviceProviders = _ref5$serviceProvider === void 0 ? [] : _ref5$serviceProvider,
      _ref5$totalCount = _ref5.totalCount,
      totalCount = _ref5$totalCount === void 0 ? 0 : _ref5$totalCount,
      _ref5$currentOffset = _ref5.currentOffset,
      currentOffset = _ref5$currentOffset === void 0 ? 0 : _ref5$currentOffset;

  var isLoading = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(businessList, 'getServiceProviders.isLoading', false); // businessListReducer redirect users with one business to homepage for Ads/Leads business.


  var showLoadingSpinner = totalCount === 1 || isLoading;

  var error = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(businessList, 'getServiceProviders.error');

  var hasNoBusinesses = totalCount === 0;
  var selectedSortBy = sortedBy.toLowerCase();

  var onCardClicked = function onCardClicked(id, proType) {
    if (proType.toLowerCase() === 'leads') {
      window.location.href = __WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform__["urlCatalog"].office.leads.homePage(id);
    } else {
      window.location.href = "/app/home/".concat(id);
    }
  };

  var spsWithNotificationCounts = serviceProviders.map(addActivityCount);
  var pageIndex = __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getPageNum(currentOffset, __WEBPACK_IMPORTED_MODULE_23__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */]) - 1;
  var pageCount = __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getPageCount(totalCount, __WEBPACK_IMPORTED_MODULE_23__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */]);
  var list = selectedSortBy === 'name' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__modules_browser_home_BusinessList_components_CategorizedList__["a" /* default */], {
    serviceProviders: spsWithNotificationCounts,
    sortField: "name",
    onCardClicked: onCardClicked
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__modules_browser_home_BusinessList_components_FlatList__["a" /* default */], {
    serviceProviders: spsWithNotificationCounts,
    onCardClicked: onCardClicked
  });
  var optionsProps = {
    setSortBy: setSortByValue,
    sortByValue: sortByValue
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "businesspage-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    lg: 3,
    md: 4,
    sm: 5,
    xsHidden: true
  }, !openFilter ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__modules_browser_home_BusinessList_components_Options__["a" /* default */], optionsProps) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__modules_browser_home_BusinessList_components_BottomDrawerModal__["a" /* default */], {
    open: openFilter,
    closeDrawer: toggleBottomFilter,
    optionProps: optionsProps
  })), showLoadingSpinner ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      minHeight: 550
    }
  }, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", {
    className: "icon icon-load text-primary icon-pulse icon-5x text-center"
  })))) : error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert___default.a, {
    bsStyle: "danger"
  }, Object(__WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform__["getErrorMessage"])(error)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    className: "businesslist-data-container",
    xs: 12,
    md: 8,
    sm: 12,
    lg: 9
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "businesslist-scroll-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "scroll-body"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "business-title-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "h2 businesslist-title"
  }, _b || (_b = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("b", null, "Choose a business to manage")), selectedSortBy !== 'name' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "h4 business-sort-type"
  }, sortTypes[selectedSortBy]))), hasNoBusinesses ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_office_app_common_lib_v1_restrictedAccess_legacyRestrictredAccess___default.a, {
    spId: 0,
    title: "You don\u2019t have any businesses yet.",
    subtitle: "When you do, you can find them here.",
    buttonText: "Refresh",
    onClick: function onClick() {
      return window.location.reload();
    },
    className: "empty-business-list-container",
    useLegacyWrapper: true,
    customIcon: _AppraisersIcon || (_AppraisersIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__modules_browser_home_common_Icons__["a" /* AppraisersIcon */], null))
  }) : [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "filter-wrapper",
    key: "0"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    lgHidden: true,
    mdHidden: true,
    smHidden: true
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    id: "options-filter-btn",
    role: "button",
    tabIndex: 0,
    className: "options-filter-btn",
    onClick: function onClick() {
      return toggleBottomFilter(true);
    },
    onKeyDown: function onKeyDown() {
      return toggleBottomFilter(true);
    }
  }, "Sort ", _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", {
    className: "icon icon-down-open"
  }))))), list]), pageCount > 1 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    md: 8
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_EllipsedPagination___default.a, {
    pageCount: pageCount,
    pageIndex: pageIndex,
    onChange: function onChange(index) {
      var newOffset = __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getOffset(index + 1, __WEBPACK_IMPORTED_MODULE_23__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */]);
      getServiceProviders({
        offset: newOffset,
        limit: __WEBPACK_IMPORTED_MODULE_23__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */],
        sortBy: sortByValue
      });
    }
  }))) : null, _HelpFooter || (_HelpFooter = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__modules_browser_home_BusinessList_components_HelpFooter__["a" /* default */], null)))));
};
var businessListPageAnalytics = {
  page: {
    name: 'SP : Business List',
    properties: __WEBPACK_IMPORTED_MODULE_14__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  },
  elements: {
    'sp-business-card': {
      click: {
        name: 'Item Clicked',
        properties: {
          'field-name': 'Bussiness Card Clicked'
        }
      },
      mouseover: {
        name: 'Item Clicked',
        properties: {
          activityLocation: 'SP : Business List',
          description: 'User hovers over the choose button on a business in the business list',
          spId: '<<attributes.spid.value>>'
        }
      }
    },
    email: Object(__WEBPACK_IMPORTED_MODULE_19__app_browser_analyticsHelpers__["b" /* itemClicked */])('SP : Business List', 'User clicks email support address'),
    phone: Object(__WEBPACK_IMPORTED_MODULE_19__app_browser_analyticsHelpers__["b" /* itemClicked */])('SP : Business List', 'User clicks phone support number')
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform__["analytics"])({
  ruleset: businessListPageAnalytics
})(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state) {
  return {
    businessList: state.businessList,
    serviceProviderCache: state.serviceProviderCache,
    experiment: state.experimentV2
  };
}, _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_24__app_common_businessList_businessListActions__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_20__app_common_serviceProvider_serviceProviderActions__["default"]))( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(BusinessListPage))));

/***/ }),

/***/ 5147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExclamatoryIcon */
/* unused harmony export WarningIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppraisersIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _svg, _svg2, _svg3;


var ExclamatoryIcon = function ExclamatoryIcon() {
  return _svg || (_svg = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: "60",
    height: "30",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    fill: "white"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7Z",
    fill: "#D71100"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M13.25 16.75C13.25 17.4404 12.6904 18 12 18C11.3096 18 10.75 17.4404 10.75 16.75C10.75 16.0596 11.3096 15.5 12 15.5C12.6904 15.5 13.25 16.0596 13.25 16.75Z",
    fill: "#D71100"
  })));
};
var WarningIcon = function WarningIcon() {
  return _svg2 || (_svg2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "28",
    cy: "28",
    r: "28",
    fill: "#E8FDF2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1455 39.2038H17.8478C17.0495 39.2038 16.3047 38.7669 15.9045 38.0639C15.5054 37.362 15.5054 36.4883 15.9045 35.7853L26.0534 17.9367C26.4536 17.2337 27.1994 16.7969 27.9977 16.7969C28.796 16.7969 29.5408 17.2337 29.941 17.9367L40.0096 35.6462L40.0321 35.6821C40.2686 36.0504 40.3948 36.4796 40.3948 36.9251C40.3948 38.1813 39.3857 39.2038 38.1455 39.2038ZM41.3879 34.8106L31.3311 17.1218C30.6452 15.9157 29.3685 15.167 27.9977 15.167C26.6259 15.167 25.3492 15.9157 24.6633 17.1218L14.5145 34.9703C13.8285 36.1765 13.8285 37.6749 14.5145 38.8789C15.2004 40.085 16.477 40.8337 17.8478 40.8337H38.1508C40.2729 40.8337 42 39.0799 42 36.9251C42 36.171 41.7881 35.4408 41.3879 34.8106ZM27.9993 32.1C28.6018 32.1 29.0919 31.6023 29.0919 30.9905V22.6226C29.0919 22.0109 28.6018 21.5132 27.9993 21.5132C27.3969 21.5132 26.9068 22.0109 26.9068 22.6226V30.9905C26.9068 31.6023 27.3969 32.1 27.9993 32.1ZM26.6448 34.8865C26.7122 34.6985 26.8299 34.5442 26.9648 34.391C27.503 33.8444 28.479 33.8444 29.0504 34.391C29.319 34.6811 29.4709 35.0571 29.4709 35.4504C29.4709 35.8427 29.319 36.236 29.0504 36.5088C28.7647 36.7826 28.3933 36.9532 28.0081 36.9532C27.6197 36.9532 27.2344 36.7826 26.9648 36.5088C26.6951 36.236 26.5282 35.8427 26.5282 35.4504C26.5282 35.2613 26.5603 35.0744 26.6448 34.8865Z",
    fill: "#333333"
  })));
}; // This icon is a copy of Appraisers from service-and-category-icon in fe-monorepo.
// It's created locally here as tailwind doesn't play nice in thunderball app.

var AppraisersIcon = function AppraisersIcon() {
  return _svg3 || (_svg3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: "72",
    height: "72",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M41.2995 22.5L49.6994 30.8999L23.0998 57.4995C20.7802 59.819 17.0195 59.819 14.6999 57.4995C12.3803 55.1799 12.3803 51.4192 14.6999 49.0996L41.2995 22.5Z",
    fill: "#8CF4BE"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M27.825 36L36.1937 44.4309L28.6063 51.9624L28.0311 46.3789C27.751 43.6594 26.5506 41.1171 24.6286 39.1728L27.825 36Z",
    fill: "#003359"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "43.4999",
    cy: "28.5",
    r: "19.5",
    fill: "#003359"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "43.5",
    cy: "28.4999",
    r: "16.5",
    fill: "#8CF4BE"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M31.5 28.5L43.5 18L55.5 28.5H51V37.5H36V28.5H31.5Z",
    fill: "#003359"
  })));
};

/***/ }),

/***/ 5148:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5149:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FlatListComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BusinessCard__ = __webpack_require__(2348);


var FlatListComponent = function FlatListComponent(props) {
  var onCardClicked = props.onCardClicked,
      serviceProviders = props.serviceProviders;
  var sps = serviceProviders || [];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-list"
  }, sps.map(function (sp) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BusinessCard__["a" /* default */], {
      key: sp.id,
      sp: sp,
      onCardClicked: onCardClicked
    });
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (FlatListComponent);

/***/ }),

/***/ 5151:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angi_url_catalog__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angi_url_catalog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angi_url_catalog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelpFooter_scss__ = __webpack_require__(5153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelpFooter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HelpFooter_scss__);
var _div, _div2;






var HelpFooter = function HelpFooter() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "businesslist-help-container"
  }, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "help-title"
  }, "Not seeing the business you\u2019re trying to manage?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "help-description-container"
  }, _div2 || (_div2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "help-description"
  }, " Learn how to manage all of your businesses with one email", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["Track"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    href: "https://intercom.help/angi/en/articles/11066470-use-a-single-sign-in-to-manage-multiple-businesses",
    id: "intercom-link",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, " here."))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "help-description"
  }, "Or, call us at", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["Track"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    href: __WEBPACK_IMPORTED_MODULE_0__angi_url_catalog___default.a.global.customerCarePhone(),
    id: "phone"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, " ", __WEBPACK_IMPORTED_MODULE_0__angi_url_catalog___default.a.global.customerCarePhoneText(), ". "))), "Monday-Friday 8AM-8PM ET and Saturday 9AM-3PM ET.")));
};

/* harmony default export */ __webpack_exports__["a"] = (HelpFooter);

/***/ }),

/***/ 5153:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CategorizedListComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CategorizedList_scss__ = __webpack_require__(5155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CategorizedList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CategorizedList_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BusinessCard__ = __webpack_require__(2348);





var getRegion = function getRegion() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$region = _ref.region,
      region = _ref$region === void 0 ? {} : _ref$region;

  return region.name;
};

var renderInfoPanel = function renderInfoPanel(letter, sps, onCardClicked) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "letter-section",
    key: letter
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "letter-header"
  }, letter), sps.map(function (sp) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BusinessCard__["a" /* default */], {
      key: sp.id,
      sp: sp,
      onCardClicked: onCardClicked
    });
  }));
};

var byState = function byState(value) {
  return getRegion(value.primaryAddress);
};

var byName = function byName(value) {
  return value.name.charAt(0).toUpperCase();
};

var getSortField = function getSortField(field) {
  switch (field) {
    case 'state':
      return byState;

    case 'name':
    default:
      return byName;
  }
};

var CategorizedListComponent = function CategorizedListComponent(props) {
  var sortField = props.sortField,
      onCardClicked = props.onCardClicked,
      serviceProviders = props.serviceProviders;
  var sps = serviceProviders || [];
  var letterToSps = sps.reduce(function (acc, value) {
    var key = getSortField(sortField)(value);

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(value);
    return acc;
  }, {});
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, Object.entries(letterToSps).map(function (_ref2) {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
        l = _ref3[0],
        orderedSps = _ref3[1];

    return renderInfoPanel(l, orderedSps, onCardClicked);
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (CategorizedListComponent);

/***/ }),

/***/ 5155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BottomDrawerModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BottomDrawerModal_scss__ = __webpack_require__(5157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BottomDrawerModal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BottomDrawerModal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Options__ = __webpack_require__(2346);



var _div, _div2;




 // eslint-disable-next-line import/no-named-as-default


var BottomDrawerModal = function BottomDrawerModal(props) {
  var closeDrawer = props.closeDrawer,
      optionProps = props.optionProps;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
      _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      openOptions = _useState2[0],
      setOpenOptions = _useState2[1];

  var domNode = document.getElementsByClassName('site-container')[0];
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    setTimeout(function () {
      return setOpenOptions(props.open);
    }, 0);

    if (props.open) {
      domNode.style.overflow = 'hidden';
    } else {
      domNode.style.overflow = 'auto';
    }
  }, [props.open]);

  var closeModal = function closeModal() {
    setOpenOptions(false);
    setTimeout(function () {
      return closeDrawer(false);
    }, 600);
    domNode.style.overflow = 'auto';
  };

  return props.open ?
  /*#__PURE__*/
  // eslint-disable-next-line function-paren-newline
  Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "bottom-drawer"
  }, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "drawer-backdrop"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('drawer-content', {
      open: openOptions
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "close-modal"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "drawer-header"
  }, _div2 || (_div2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "drawer-header-title"
  }, "Sort")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("i", {
    className: "icon icon-close",
    role: "button",
    tabIndex: 0,
    onClick: closeModal,
    onKeyDown: closeModal
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Options__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    closeFilter: closeModal
  }, optionProps)))), domNode) : null;
};
/* harmony default export */ __webpack_exports__["a"] = (BottomDrawerModal);

/***/ }),

/***/ 5157:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export UnifiedBusinessListViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_hot_loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Alert__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__unifiedBusinessListView_scss__ = __webpack_require__(5159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__unifiedBusinessListView_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__unifiedBusinessListView_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_BusinessList__ = __webpack_require__(5160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(215);







var _div, _BusinessList;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}












var prosPerPage = 20;
var UnifiedBusinessListViewComponent = /*#__PURE__*/function (_React$Component) {
  function UnifiedBusinessListViewComponent() {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, UnifiedBusinessListViewComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper(this, UnifiedBusinessListViewComponent, [].concat(args));

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "props", void 0);

    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(UnifiedBusinessListViewComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(UnifiedBusinessListViewComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var getCurrentUsersServiceProviders = this.props.getCurrentUsersServiceProviders; // TODO make prosPerPage an API limit

      getCurrentUsersServiceProviders({
        offset: 0,
        limit: prosPerPage,
        sortBy: 'name'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$businessL = this.props.businessList.getCurrentUsersServiceProviders,
          request = _this$props$businessL.request,
          response = _this$props$businessL.response,
          error = _this$props$businessL.error;

      var _ref = response || {},
          _ref$serviceProviders = _ref.serviceProviders,
          serviceProviders = _ref$serviceProviders === void 0 ? [] : _ref$serviceProviders;

      var _ref2 = request || {},
          _ref2$offset = _ref2.offset,
          offset = _ref2$offset === void 0 ? 0 : _ref2$offset;

      var showBusinessList = offset > 0 || serviceProviders.length > 1 && offset === 0;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: ".business-list--unified-view-centering"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid___default.a, {
        className: "business-list--grid"
      }, !showBusinessList ? [error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger",
        key: "0"
      }, Object(__WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["getErrorMessage"])(error)) : null, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: "text-center",
        key: "1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("i", {
        className: "icon icon-load text-primary icon-pulse icon-5x text-center"
      })))] : _BusinessList || (_BusinessList = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_BusinessList__["a" /* default */], null))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_6_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(function (state) {
  return {
    businessList: state.businessList
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_16__app_common_serviceProvider_serviceProviderActions__["default"])), __WEBPACK_IMPORTED_MODULE_7_recompose_pure___default.a)(UnifiedBusinessListViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BusinessListComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Alert__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Input__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_EllipsedPagination__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_EllipsedPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_EllipsedPagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddedBusinessHandler__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_browser_BusinessInfoPanel__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__businessList_scss__ = __webpack_require__(5161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__businessList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__businessList_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__businessListAnalytics__ = __webpack_require__(5162);



var _small, _option, _option2, _option3, _option4, _AddedBusinessHandler, _i;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var prosPerPage = 20;
var activityLocation = 'SP : Business List';

var renderInfoPanel = function renderInfoPanel() {
  return function (_ref) {
    var serviceProvider = _ref.serviceProvider,
        entitlements = _ref.entitlements;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__app_browser_BusinessInfoPanel__["a" /* default */], {
      key: serviceProvider.id,
      activityLocation: activityLocation,
      showBusinessListLink: false,
      serviceProvider: serviceProvider,
      entitlements: entitlements
    });
  };
};

var renderSortDropdown = function renderSortDropdown(currentSort, getCurrentUsersServiceProviders) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    className: "form-inline business-list--sort-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Input___default.a, {
    type: "select",
    label: _small || (_small = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("small", null, "Sort by:")),
    id: "business-list--sort-by",
    value: currentSort,
    labelClassName: "sort-by-label",
    onChange: function onChange(event) {
      return getCurrentUsersServiceProviders({
        offset: 0,
        limit: prosPerPage,
        sortBy: event.target.value
      });
    }
  }, _option || (_option = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
    value: "name"
  }, "Business Name")), _option2 || (_option2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
    value: "overall_gpa"
  }, "Ratings (5-1)")), _option3 || (_option3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
    value: "overall_reviews"
  }, "Reviews")), _option4 || (_option4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
    value: "alId"
  }, "SPID"))));
};

var BusinessListComponent = function BusinessListComponent(props) {
  var _props$businessList = props.businessList,
      _props$businessList$g = _props$businessList.getCurrentUsersServiceProviders,
      request = _props$businessList$g.request,
      response = _props$businessList$g.response,
      isLoading = _props$businessList$g.isLoading,
      error = _props$businessList$g.error,
      _props$businessList$g2 = _props$businessList.getServiceProvider,
      isLoadingDetails = _props$businessList$g2.isLoading,
      errorDetails = _props$businessList$g2.error,
      serviceProviderCache = props.serviceProviderCache,
      getCurrentUsersServiceProviders = props.getCurrentUsersServiceProviders,
      userResponse = props.user.userInfo.response;

  var _ref2 = response || {},
      _ref2$serviceProvider = _ref2.serviceProviders,
      serviceProviders = _ref2$serviceProvider === void 0 ? [] : _ref2$serviceProvider,
      _ref2$total = _ref2.total,
      total = _ref2$total === void 0 ? 0 : _ref2$total;

  var _ref3 = userResponse || {},
      _ref3$entitlements = _ref3.entitlements,
      entitlements = _ref3$entitlements === void 0 ? [] : _ref3$entitlements;

  var entitlementsBySPID = __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy___default()(entitlements.filter(function (e) {
    return e.scope === 'ServiceProvider';
  }), function (e) {
    return e.scopeId;
  });

  var serviceProviderDetails = serviceProviders.map(function (x) {
    return _objectSpread(_objectSpread({}, serviceProviderCache[String(x.id)]), x);
  });
  var serviceProviderDetailsWithEntitlements = serviceProviderDetails.map(function (x) {
    return {
      serviceProvider: x,
      entitlements: entitlementsBySPID["".concat(x.id)]
    };
  });

  var _ref4 = request || {},
      _ref4$limit = _ref4.limit,
      limit = _ref4$limit === void 0 ? prosPerPage : _ref4$limit,
      _ref4$offset = _ref4.offset,
      offset = _ref4$offset === void 0 ? 0 : _ref4$offset,
      _ref4$sortBy = _ref4.sortBy,
      sortBy = _ref4$sortBy === void 0 ? 'name' : _ref4$sortBy;

  var pageIndex = __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getPageNum(offset, limit) - 1;
  var pageCount = __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getPageCount(total, limit);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    className: "business-list"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row___default.a, {
    className: "business-list--header-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    sm: 8
  }, serviceProviders.length > 1 ? _AddedBusinessHandler || (_AddedBusinessHandler = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AddedBusinessHandler__["a" /* default */], null)) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h1", {
    style: {
      fontSize: 32
    }
  }, "Business List", isLoading || isLoadingDetails ? _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", {
    className: "icon icon-load text-primary icon-pulse"
  })) : null), error || errorDetails ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Alert___default.a, {
    bsStyle: "danger"
  }, Object(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__["getErrorMessage"])(error || errorDetails)) : null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col___default.a, {
    sm: 4
  }, serviceProviders.length > 1 ? renderSortDropdown(sortBy, getCurrentUsersServiceProviders) : null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("hr", {
    className: "hidden-xs",
    style: {
      margin: '4px 0 32px 0'
    }
  }), serviceProviderDetailsWithEntitlements.map(renderInfoPanel()), pageCount > 1 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col___default.a, {
    xs: 12
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_EllipsedPagination___default.a, {
    pageCount: pageCount,
    pageIndex: pageIndex,
    onChange: function onChange(index) {
      return getCurrentUsersServiceProviders({
        offset: __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getOffset(index + 1, prosPerPage),
        limit: prosPerPage,
        sortBy: sortBy
      });
    }
  }))) : null);
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__["legacyAnalytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_17__businessListAnalytics__["a" /* default */]
}), Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state) {
  return {
    businessList: state.businessList,
    serviceProviderCache: state.serviceProviderCache,
    user: state.user
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_16__app_common_serviceProvider_serviceProviderActions__["default"])), __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default.a)(BusinessListComponent));

/***/ }),

/***/ 5161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__ = __webpack_require__(42);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ __webpack_exports__["a"] = ({
  page: {
    name: 'SP : Business List',
    properties: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */])
  }
});

/***/ }),

/***/ 5163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_compose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_setPropTypes__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_setPropTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_setPropTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/**
 * Functional wrapper for switching between app configs.
 * It keeps all props switching isolated to single function
 */




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    config: state.config,
    experiment: state.experimentV2
  };
}), __WEBPACK_IMPORTED_MODULE_1_recompose_setPropTypes___default()({
  config: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    appName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
  }).isRequired,
  experiment: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
})));

/***/ }),

/***/ 5164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform_lib_common_poller_pollerActions__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform_lib_common_poller_pollerActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform_lib_common_poller_pollerActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform_lib_common_poller_pollerReducer__ = __webpack_require__(5165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform_lib_common_poller_pollerReducer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform_lib_common_poller_pollerReducer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_common_download_appDownloadReducer__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_businessListReducer__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_homeReducer__ = __webpack_require__(5168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_welcomeReducer__ = __webpack_require__(5169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_serviceAreaMapReducer__ = __webpack_require__(5170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_performanceReducer__ = __webpack_require__(5171);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









/* harmony default export */ __webpack_exports__["default"] = ({
  beforeConfigureStore: function beforeConfigureStore(options) {
    var ionOptions = {
      reducers: _objectSpread(_objectSpread({}, (options || {}).reducers), {}, {
        appDownload: __WEBPACK_IMPORTED_MODULE_3__app_common_download_appDownloadReducer__["a" /* default */],
        businessList: __WEBPACK_IMPORTED_MODULE_4__common_businessListReducer__["a" /* default */],
        home: __WEBPACK_IMPORTED_MODULE_5__common_homeReducer__["a" /* default */],
        performance: __WEBPACK_IMPORTED_MODULE_8__common_performanceReducer__["a" /* default */],
        poller: __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform_lib_common_poller_pollerReducer___default.a,
        welcome: __WEBPACK_IMPORTED_MODULE_6__common_welcomeReducer__["a" /* default */],
        serviceAreaMap: __WEBPACK_IMPORTED_MODULE_7__common_serviceAreaMapReducer__["a" /* default */]
      })
    };
    ionOptions.reducers.home.persist = true;
    return ionOptions;
  },
  afterConfigureStore: function afterConfigureStore(store) {
    if (true) {
      store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform_lib_common_poller_pollerActions__["getConfig"])());
    }
  }
});

/***/ }),

/***/ 5165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(2));

var _get2 = _interopRequireDefault(__webpack_require__(5));

var _pollerActionKeys = __webpack_require__(2128);

var _redux = __webpack_require__(40);

var _createReducer4 = _interopRequireDefault(__webpack_require__(173));

var _AsyncRequest = _interopRequireDefault(__webpack_require__(358));

var _Poller = __webpack_require__(5166);

var _createReducer2, _createReducer3;

var _default = (0, _redux.combineReducers)({
  config: _AsyncRequest.default.createReducer(_pollerActionKeys.GET_CONFIG, (0, _defineProperty2.default)({}, _pollerActionKeys.GET_CONFIG_SUCCESS, function (state, action) {
    var interval = (0, _get2.default)(action, 'payload.body.interval', _Poller.DEFAULT_POLLER_INTERVAL);

    _Poller.poller.setTimer(interval);

    return _AsyncRequest.default.setSuccess(state, action.payload.body);
  })),
  interval: (0, _createReducer4.default)(_Poller.DEFAULT_POLLER_INTERVAL, (0, _defineProperty2.default)({}, _pollerActionKeys.GET_CONFIG_SUCCESS, function (state, action) {
    return (0, _get2.default)(action, 'payload.body.interval');
  })),
  active: (0, _createReducer4.default)(_Poller.poller.isActive(), (_createReducer2 = {}, (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.GET_CONFIG_SUCCESS, function (state, action) {
    return true;
  }), (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.START_POLLING, function (state, action) {
    return true;
  }), (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.STOP_ALL_POLLING, function (state, action) {
    return false;
  }), (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.STOP_POLLING, function (state, action) {
    return _Poller.poller.isActive();
  }), _createReducer2), false),
  poller: (0, _createReducer4.default)({}, (_createReducer3 = {}, (0, _defineProperty2.default)(_createReducer3, _pollerActionKeys.START_POLLING, function (state, action) {
    var callback = action.payload;

    _Poller.poller.start(callback);

    return state;
  }), (0, _defineProperty2.default)(_createReducer3, _pollerActionKeys.STOP_POLLING, function (state, action) {
    var callbackId = action.payload;

    _Poller.poller.stop(callbackId);

    return state;
  }), (0, _defineProperty2.default)(_createReducer3, _pollerActionKeys.STOP_ALL_POLLING, function (state, action) {
    _Poller.poller.endPolling();

    return state;
  }), _createReducer3), false)
});

exports.default = _default;
module.exports = exports.default;

/***/ }),

/***/ 5166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(3);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.poller = exports.default = exports.Poller = exports.DEFAULT_POLLER_INTERVAL = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _isUndefined2 = _interopRequireDefault(__webpack_require__(126));

var _isFinite2 = _interopRequireDefault(__webpack_require__(5167));

var _isFunction2 = _interopRequireDefault(__webpack_require__(166));

var DEFAULT_POLLER_INTERVAL = 60000;
exports.DEFAULT_POLLER_INTERVAL = DEFAULT_POLLER_INTERVAL;

var Poller = /*#__PURE__*/function () {
  function Poller() {
    (0, _classCallCheck2.default)(this, Poller);
    this.intervalRegistry = [];
    this.TIMER = DEFAULT_POLLER_INTERVAL;
  }

  (0, _createClass2.default)(Poller, [{
    key: "_runCallback",
    value: function _runCallback(registeredCallback) {
      return (0, _isFunction2.default)(registeredCallback) ? registeredCallback() : undefined;
    }
  }, {
    key: "_runAll",
    value: function _runAll() {
      this.intervalRegistry.forEach(this._runCallback);
    }
  }, {
    key: "_beginPolling",
    value: function _beginPolling() {
      var _this = this;

      this.interval = setInterval(function () {
        return _this._runAll();
      }, this.TIMER);
    }
  }, {
    key: "_togglePolling",
    value: function _togglePolling() {
      if (this.intervalRegistry.length && !this.interval) {
        this._beginPolling();
      } else if (this.intervalRegistry.length === 0 && this.interval) {
        this.endPolling();
      }
    }
  }, {
    key: "endPolling",
    value: function endPolling() {
      this.intervalRegistry = [];
      this.interval = clearInterval(this.interval);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.intervalRegistry.length > 0;
    }
  }, {
    key: "start",
    value: function start(intervalCallback) {
      // Check to see that FN is not already in registry
      if (this.intervalRegistry.indexOf(intervalCallback) === -1 && (0, _isFunction2.default)(intervalCallback)) {
        this.intervalRegistry.push(intervalCallback);

        this._togglePolling();
      }

      return this.isActive();
    }
  }, {
    key: "stop",
    value: function stop(intervalCallbackId) {
      if ((0, _isFunction2.default)(intervalCallbackId)) {
        this.intervalRegistry = this.intervalRegistry.filter(function (cb) {
          return cb !== intervalCallbackId;
        });

        this._togglePolling();
      }

      return this.isActive();
    }
  }, {
    key: "setTimer",
    value: function setTimer(interval) {
      if ((0, _isFinite2.default)(parseInt(interval, 10))) {
        this.TIMER = interval;
      } // If new value is set, restart poller.


      if (!(0, _isUndefined2.default)(this.interval)) {
        clearInterval(this.interval);

        this._beginPolling();
      }

      return this.isActive();
    }
  }]);
  return Poller;
}();

exports.Poller = Poller;
var poller = new Poller();
exports.poller = poller;
var _default = poller;
exports.default = _default;

/***/ }),

/***/ 5167:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(237);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

module.exports = isFinite;


/***/ }),

/***/ 5168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__homeActionKeys__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_common_user_userActionKeys__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__homeActions__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(215);









var viewedWelcomeModal = Object(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["createReducer"])(new __WEBPACK_IMPORTED_MODULE_4_immutable___default.a.Map(), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5__homeActionKeys__["a" /* default */].MARK_MODAL_SEEN, function (state, action) {
  return state.set(action.payload.spid, true);
}), true);
var sentHomePageVisitEvent = Object(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["createReducer"])(false, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6__app_common_user_userActionKeys__["a" /* default */].GET_USER_SUCCESS, function (state, action) {
  if (!state) {
    action.addSideEffect(function (store) {
      store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__homeActions__["sendHomePageVisitEvent"])());
    });
    return true;
  }

  return state;
}));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["combineReducers"])({
  viewedWelcomeModal: viewedWelcomeModal,
  sentHomePageVisitEvent: sentHomePageVisitEvent,
  getAllHighlights: __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_5__homeActionKeys__["a" /* default */].GET_ALL_HIGHLIGHTS),
  updateBusinessHighlights: __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_5__homeActionKeys__["a" /* default */].UPDATE_BUSINESS_HIGHLIGHTS, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5__homeActionKeys__["a" /* default */].UPDATE_BUSINESS_HIGHLIGHTS_SUCCESS, function (state, action) {
    action.addSideEffect(function (store) {
      var storeState = store.getState();

      var serviceProviderId = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(storeState, 'serviceProviderId');

      store.dispatch(__WEBPACK_IMPORTED_MODULE_8__app_common_serviceProvider_serviceProviderActions__["default"].getServiceProvider(serviceProviderId));
    });
    return __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["AsyncRequest"].setSuccess(state, action.payload);
  }))
}));

/***/ }),

/***/ 5169:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_common_categories_categoriesActionKeys__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__welcomeActionKeys__ = __webpack_require__(2332);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  updateBusinessDescription: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_3__welcomeActionKeys__["a" /* default */].UPDATE_BUSINESS_DESCRIPTION),
  categoriesToAdd: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_categories_categoriesActionKeys__["a" /* default */].ADD_CATEGORIES_TO_SERVICE_PROVIDER),
  serviceProviderCategories: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_categories_categoriesActionKeys__["a" /* default */].GET_SERVICE_PROVIDER_CATEGORIES)
}));

/***/ }),

/***/ 5170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_common_service_area_serviceAreaMapActionKeys__ = __webpack_require__(1367);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  citySearch: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_service_area_serviceAreaMapActionKeys__["a" /* default */].SEARCH_CITIES),
  cityDetails: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_service_area_serviceAreaMapActionKeys__["a" /* default */].GET_CITY_DETAILS),
  setServiceArea: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_service_area_serviceAreaMapActionKeys__["a" /* default */].SET_SERVICE_AREA)
}));

/***/ }),

/***/ 5171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export contactMetrics */
/* unused harmony export contactMetricsByCategory */
/* unused harmony export callLog */
/* unused harmony export customerAttributes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__ = __webpack_require__(2343);



var contactMetrics = __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__["a" /* default */].GET_CONTACT_METRICS_BY_SERVICE_PROVIDER);
var contactMetricsByCategory = __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__["a" /* default */].GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER);
var callLog = __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__["a" /* default */].GET_CALL_LOG_BY_SERVICE_PROVIDER);
var customerAttributes = __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__["a" /* default */].GET_CUSTOMER_ATTRIBUTES_BY_UUID);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"])({
  contactMetrics: contactMetrics,
  contactMetricsByCategory: contactMetricsByCategory,
  callLog: callLog,
  customerAttributes: customerAttributes
}));

/***/ })

},[5038]);


// WEBPACK FOOTER //
// home-0d3422812c087f53a753.js